import React, { useState, useEffect} from 'react';
import Select from "react-select";
import './Transactions_by_user.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {  useNavigate } from 'react-router-dom';
import {
  Badge,
  Col,
  Form,
  Row,
} from 'react-bootstrap';
import { get_all_members, load_awards_log } from '../../../utils/talent_services';
import { get_account_list } from '../../../utils/services';



function Awards  ({usr_id, permission, onSet}) {
    // --- Estado de filtros/orden/columnas ---
    const navigate = useNavigate();   
    const [usrList, setUsrList] = useState([]);

    const token = localStorage.getItem("token");
    const [selectedUsr, setselectedUsr] = useState(null);
    const today = new Date();
    // Calcular la fecha de hace 30 días
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);

    const [awards, setAwards] = useState([]);
    
      

  
    useEffect(() => {

      fetloadInternalTeam(token,0);
 
    }, [token, usr_id]); 
    
    useEffect(()=>{
      setselectedUsr(getOptionByValue(usr_id));
    }
   , [usrList]);
    

    useEffect(() => {
      if (selectedUsr!=null)
        fetloadcurrentUserAwards(token,selectedUsr.value);
     
    }, [selectedUsr]); 
  


    // --- cargo todos los usuarios
    async function fetloadInternalTeam(token, type) {
            const usrData = await get_account_list(token, type);
                         if (usrData==="INVALID"){
                             navigate("/");
                         }
                         else{
                           const tempUsr_list = usrData["accountlist"].map((celement, index) => {
                             return {
                               id: celement.id,
                               value: celement.id,
                               email_id: celement.email_id,
                               label: celement.usr_name ,
                               index:index
                             };
                           });
           
                          
                           setUsrList(tempUsr_list);
                           
                           
                        
                         }
        }

    const getOptionByValue = (value) => {
      return usrList.find(option => option.value === value);
    };
  async function fetloadcurrentUserAwards(token, usr_id_selected) {
      const opp_log = await load_awards_log(token, usr_id_selected);
      if (opp_log==="INVALID"){
          navigate("/");
      }else{
  
       const templog= opp_log.map((celement, index) => {
         return {
             id: celement.id,
             issue_date: celement.date_creation,
             description: celement.comment,
             type_name: celement.type_name,
             issue_type: celement.type,
             user_by: celement.usr_name,
             index:index
         };
       });
  
        setAwards( templog);
          
      }
  }

  


  
    // ---------- UI ----------
    return (
      <div className="container-fluid px-2 px-md-3 py-3">

        
        <h1 className="mb-4 fw-bold">Reconocimientos Internos</h1>
        {/* Barra de búsqueda + menús */}

        <div className="d-flex gap-2 mb-3 flex-wrap align-items-center" > {/* El gap-2 aquí crea el espacio entre los hijos directos */}

                 <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={usrList}
                    value={selectedUsr}
                    onChange={(selectedOption) => setselectedUsr(selectedOption)}
                    placeholder="Buscar persona..."
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        minWidth: 300, // o usa width: '100%' para expansión completa
                        flex: 1,       // permite que crezca en d-flex
                      }),
                        menu: (provided) => ({
                            ...provided,
                            zIndex: 9999 // Un valor alto para asegurar que aparezca encima de todo
                        }),
                        // Opcional: Si el menú se renderiza en un portal, también puedes ajustar su zIndex
                        menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999
                        })
                    }}
                    isSearchable
                />
           
            
 
        </div>   
    
        

          <Row className="mt-4 text-start">
                <Col>
                  <Form.Label>Reconocimientos:</Form.Label>
                
                  <div className="log-box text-left"> {/* Aseguramos que el contenedor principal alinee su texto a la izquierda */}
                    {awards.length === 0 ? (
                      <p className="text-gray-500 italic">No hay entradas en el registro aún.</p>
                    ) : (
                      awards.map((l) => (
                        <div key={l.id} className="bg-light p-3 rounded mb-3 shadow-sm border">
                          <div className="d-flex flex-column flex-sm-row align-items-sm-baseline mb-2 gap-3">
                           {/*
                            <Badge  
                              bg="warning"
                              pill
                              className="chip d-inline-flex align-items-center px-3 py-2 fs-8"
                            >
                              {l.user_by}
                            </Badge>
                            */
                            }
                            {/* Fecha */}
                            <span className="text-muted small">
                              {new Date(l.issue_date).toLocaleString()}
                            </span>
        
                          
                          </div>
        
                          {/* Descripción */}
                          <p className="text-dark lh-sm text-start">{l.description}</p>
                        </div>
                      ))
                    )}
                  </div>
                </Col>
              </Row>


      </div>
    );
};

export default Awards;
